module.exports = __webpack_public_path__ + "img/head.29d83676.png";